import { useEffect, useState } from "react";
//---------------------------------------------------------------------
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import { myAxios, MyFormData } from "src/components/common/functions";
//---------------------------------------------------------------------
export default function Form({
    id, setRenderSwitch, rawData,
    closeIt
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const [curSettings, setSettings] = useState(rawData[id]?.questions ?? {});
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [keyword, setKeyword] = useState(rawData[id]?.questions?.name || "Loading...");
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            const formData = new MyFormData();
            formData.append("fileId", id);
            //-------------------------------------------------------------
            setShowLoader(true);
            const res = await myAxios("common/getJSONData.php", formData);
            if(!isMounted) return;
            setShowLoader(false);
            if(!res) return;
            //-------------------------------------------------------------
            setSettings(res.data);
            setKeyword(res.data.name);
        }
        if(!rawData[id] || (rawData[id] && rawData[id].status !== "Saved")) getData();
        return () => {isMounted = false;}
    },[id, rawData])
    //--------------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = {keyword}
            width = {"900px"}
            maxWidth = {"100%"}
            actionKey = {currentQuestionIndex === curSettings.questions?.length - 1?
                "Submit"
            :null} 
            handleFormSubmit = {currentQuestionIndex === curSettings.questions?.length - 1?
                async() => {
                    const totalScore = curSettings.questions.length;
                    let curScore = 0;
                    for(let question of curSettings.questions){
                        if(question.multi){
                            let thisScore = 1;
                            for(let option of question.options){
                                if(option.selected && !option.answer){
                                    thisScore = 0;
                                }
                                if(!option.selected && option.answer){
                                    thisScore = 0.5;
                                }
                            }
                            curScore += thisScore;
                        }else{
                            if(question.options.find(option => option.selected).answer) curScore++;
                        }
                    }
                    const formData = new MyFormData();
                    formData.append("trainingId", user.trainingId);
                    formData.append("data", JSON.stringify(
                        {...rawData, [id]: {
                            status: curScore >= curSettings.passScore?"Passed":"Failed", 
                            curScore: curScore, totalScore: totalScore
                        }}
                    ));
                    //-------------------------------------------------------------
                    setShowLoader(true);
                    const res = await myAxios("training/trainingData.php", formData);
                    setShowLoader(false);
                    if(!res) return;
                    //-------------------------------------------------------------
                    user.trainingId = res.data;
                    closeIt();
                    setRenderSwitch(s => !s);
                }
            :null}
            onSave = {async() => {
                const formData = new MyFormData();
                formData.append("trainingId", user.trainingId);
                formData.append("data", JSON.stringify(
                    {...rawData, [id]: {status: "Saved", questions: curSettings}}
                ));
                //-------------------------------------------------------------
                setShowLoader(true);
                const res = await myAxios("training/trainingData.php", formData);
                setShowLoader(false);
                if(!res) return;
                //-------------------------------------------------------------
                user.trainingId = res.data;
                closeIt();
                setRenderSwitch(s => !s);
            }}
        >
            {
            // curSettings.questions?.map((question, questionIndex) => <div key = {questionIndex} className = "my-3">
            //     <div className = "m-3" style = {{whiteSpace: "pre-wrap"}}>Question {questionIndex + 1}: {question.name}</div>
            //     {question.options.map((opt, optIndex) => <div key = {optIndex} className = "m-3">
            //         <span className = "mr-3">{opt.name}</span>
            //         <input 
            //             name = {question.name}
            //             type = {question.multi?"checkbox":"radio"} 
            //             className = "form-control" 
            //             style = {{width:30, height:30}} 
            //             value = {opt.name} 
            //             checked = {opt.selected || false}
            //             onChange = {e => {
            //                 if(e.currentTarget.checked){
            //                     //practice mode
            //                     if(curSettings.mode === "Practice"){
            //                         setSettings({...curSettings, questions:[
            //                             ...curSettings.questions.slice(0, questionIndex), 
            //                             {
            //                                 ...question,
            //                                 options: [...question.options.slice(0, optIndex).map(opt0 => ({...opt0, selected: question.multi?opt0.selected:false})), {...opt, 
            //                                     selected: e.currentTarget.checked
            //                                 } , ...question.options.slice(optIndex + 1).map(opt1 => ({...opt1, selected: question.multi?opt1.selected:false}))],
            //                                 signleAnswer: e.currentTarget.value
            //                             },
            //                             ...curSettings.questions.slice(questionIndex + 1)
            //                         ]});
            //                     }
            //                 }
            //             }}
            //         />
            //         {curSettings.mode === "Practice" && opt.selected?<span className = "ml-3">
            //         {opt.answer?<span className = "text-success">Correct</span>:<span className = "text-danger">Wrong</span>} {opt.comment}
            //         </span>:null}
            //     </div>)}
            // </div>)
            }
            {curSettings.questions?<div className = "my-3">
                <div className = "m-3" style = {{whiteSpace: "pre-wrap"}}>Question {currentQuestionIndex + 1}: {curSettings.questions[currentQuestionIndex].name}</div>
                {curSettings.questions[currentQuestionIndex].options.map((opt, optIndex) => <div key = {optIndex} className = "m-3">
                    <span className = "mr-3">{opt.name}</span>
                    <input 
                        name = {curSettings.questions[currentQuestionIndex].name}
                        type = {curSettings.questions[currentQuestionIndex].multi?"checkbox":"radio"} 
                        
                        style = {{width:30, height:30}} 
                        value = {opt.name} 
                        checked = {opt.selected || false}
                        onChange = {e => {
                            setSettings({...curSettings, questions:[
                                ...curSettings.questions.slice(0, currentQuestionIndex), 
                                {
                                    ...curSettings.questions[currentQuestionIndex],
                                    options: [...curSettings.questions[currentQuestionIndex].options.slice(0, optIndex).map(opt0 => ({...opt0, selected: curSettings.questions[currentQuestionIndex].multi?opt0.selected:false})), {...opt, 
                                        selected: e.currentTarget.checked
                                    } , ...curSettings.questions[currentQuestionIndex].options.slice(optIndex + 1).map(opt1 => ({...opt1, selected: curSettings.questions[currentQuestionIndex].multi?opt1.selected:false}))],
                                    signleAnswer: e.currentTarget.value
                                },
                                ...curSettings.questions.slice(currentQuestionIndex + 1)
                            ]});
                        }}
                    />
                    {curSettings.mode === "Practice" && opt.selected?<span className = "ml-3">
                    {opt.answer?<span className = "text-success">Correct</span>:<span className = "text-danger">Wrong</span>} {opt.comment}
                    </span>:null}
                </div>)}
            </div>:null}

            <div className = "m-3">
            {currentQuestionIndex > 0?<span className = "mr-3 btn btn-info" onClick = {() => {
                    setCurrentQuestionIndex(i => i - 1);
                }}>Previous</span>:null}
                {currentQuestionIndex < curSettings.questions?.length - 1?<span className = "btn btn-primary" onClick = {() => {
                    setCurrentQuestionIndex(i => i + 1);
                }}>Next</span>:null}
                
            </div>
        </Modal>
    )
}